import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PrivacyPolicy } from './PrivacyPolicy';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <footer className="bg-[#060e1a] border-t border-white/5 pt-16 pb-8" data-id="element-72">
      <div className="max-w-7xl mx-auto px-6" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-74">
          {/* Brand */}
          <div data-id="element-75">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-76">LKHV.eu</h3>
            <p className="text-white/50 text-sm leading-relaxed mb-6" data-id="element-77">
              Neveřejné vnitrostátní letiště provozované{' '}
              <a href="https://www.aviatickyklubtlustice.cz" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#38bdf8] transition-colors underline-offset-2 hover:underline" data-id="element-78">
                Aviatickým klubem Tlustice.
              </a>
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-79">
            <h4 className="text-white font-semibold mb-6" data-id="element-80">Rychlé odkazy</h4>
            <ul className="space-y-1.5" data-id="element-81">
              {[{
              label: 'O letišti',
              href: '#hero'
            }, {
              label: 'Služby',
              href: '#services'
            }, {
              label: 'Akce',
              href: '#events'
            }, {
              label: 'Pro piloty',
              href: '#pilot-info'
            }, {
              label: 'Briefing',
              href: '/briefing',
              isRoute: true
            }, {
              label: 'Kontakt',
              href: '#contact'
            }].map(item => <li key={item.label} data-id="element-82">
                  {'isRoute' in item && item.isRoute ? <Link to={item.href} className="text-white/50 hover:text-[#38bdf8] text-sm transition-colors" data-id="element-83">
                      {item.label}
                    </Link> : <a href={item.href} className="text-white/50 hover:text-[#38bdf8] text-sm transition-colors" data-id="element-84">
                      {item.label}
                    </a>}
                </li>)}
            </ul>
          </div>

          {/* Contact Summary */}
          <div data-id="element-85">
            <h4 className="text-white font-semibold mb-6" data-id="element-86">Kontakt</h4>
            <ul className="space-y-3 text-sm text-white/50" data-id="element-87">
              <li data-id="element-88">
                <a href="https://aviatickyklubtlustice.cz/" target="_blank" rel="noopener noreferrer" className="hover:text-[#38bdf8] transition-colors" data-id="element-89">
                  Aviatický klub Tlustice, z.s.
                </a>
              </li>
              <li data-id="element-90">č.p. 258, 268 01 Tlustice</li>
              <li data-id="element-91">+420 606 730 374</li>
              <li data-id="element-92">info@aviatickyklubtlustice.cz</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-93">
          <p className="text-white/30 text-xs" data-id="element-94">
            © 2026 LKHV Letiště Hořovice. Všechna práva vyhrazena.
          </p>
          <div className="flex space-x-6 text-xs text-white/30" data-id="element-95">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-96">
              Ochrana soukromí
            </button>
          </div>
        </div>
      </div>

      <PrivacyPolicy isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} data-id="element-97" />
    </footer>;
}